(function () {
  function isGiftCard(item) {
    return Boolean(item.gift_card) || Number(item.product_id) === 16159971148125 || item.handle === 'vuoplug-gift-card';
  }

  function subtotal(cart) {
    const giftProduct = Number((window.VP_GIFT || {}).product || 16241211408733);
    return (cart.items || []).reduce(function (total, item) {
      if (isGiftCard(item) || Number(item.product_id) === giftProduct) return total;
      return total + Math.max(0, Number(item.final_line_price) || 0);
    }, 0);
  }

  window.VP_GIFT_ELIGIBILITY = { isGiftCard: isGiftCard, subtotal: subtotal };
})();
